/* eslint-disable @typescript-eslint/no-explicit-any */
import { isEmpty } from "lodash";
const generateColumns = (count = 10, prefix = "column-", props) => new Array(count).fill(0).map((column, columnIndex) => (Object.assign(Object.assign({}, props), { key: `${prefix}${columnIndex}`, dataKey: `${prefix}${columnIndex}`, title: `Column ${columnIndex}`, width: 100, sortable: true })));
const generateData = (columns, count = 20, prefix = "row-") => new Array(count).fill(0).map((row, rowIndex) => {
    return columns.reduce((rowData, column, columnIndex) => {
        rowData[column.dataKey] = `Row ${rowIndex} - Col ${columnIndex}`;
        return rowData;
    }, {
        id: `${prefix}${rowIndex}`,
        parentId: null
    });
});
export const checkIfTablehasFooter = (props) => {
    const { footerLeftActions, footerRightActions, columnsEditable, hasFilters, enablePagination } = props;
    return (!isEmpty(footerLeftActions) ||
        !isEmpty(footerRightActions) ||
        columnsEditable ||
        hasFilters ||
        enablePagination);
};
export { generateColumns, generateData };
